import { Tenant } from '@wpp-open/core'

import { LegacyTenantCode } from 'legacy/types/osWebRootApi'
import { WorkspaceAgency } from 'types/agencies/workspaceAgency'

export const getCurrentTenantCode = ({ tenant, agencies }: { tenant: Tenant; agencies: WorkspaceAgency[] }) => {
  const currentAgency = agencies.find(({ azId }) => azId === tenant.azId) || agencies[0]
  return currentAgency.code as LegacyTenantCode
}
